import { CurecallDateTimePicker } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

type TAppointmentDatePickerProps = {
  name: string
  label?: string
  isRequired?: boolean
  requiredErrorMessage?: string
  defaultValue?: Date
  tooltipContent?: string
  timezone?: string
}

const AppointmentDatePicker = ({
  label,
  name,
  isRequired = false,
  requiredErrorMessage,
  tooltipContent,
  timezone,
}: TAppointmentDatePickerProps) => {
  const {
    setValue,
    clearErrors,
    register,
    formState: { errors, defaultValues },
    getValues,
  } = useFormContext()
  const { t } = useTranslation()

  const dateAlreadySaved = getValues(name)
  const defaultSelectedDateAndTime = dateAlreadySaved || defaultValues?.[name]

  useEffect(() => {
    register(name, { required: isRequired })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register])

  return (
    <CurecallDateTimePicker
      label={label || t('components.appointment-date-picker.date')}
      onChangeDateTime={(date) => {
        setValue(name, date)
        if (date) clearErrors(name)
      }}
      defaultDateTime={defaultSelectedDateAndTime}
      isRequired={isRequired}
      localeLanguage={navigator.language}
      errorMessage={errors[name] ? requiredErrorMessage : ''}
      tooltipContent={tooltipContent}
      tooltipPosition="bottom"
      inputClassName="c-w-[170px]"
      timezone={timezone}
    />
  )
}

export default AppointmentDatePicker
